export const hoosScoreData = [
  { raw_score: 0, interval_score: 100.0 },
  { raw_score: 1, interval_score: 92.34 },
  { raw_score: 2, interval_score: 85.257 },
  { raw_score: 3, interval_score: 80.55 },
  { raw_score: 4, interval_score: 76.776 },
  { raw_score: 5, interval_score: 73.472 },
  { raw_score: 6, interval_score: 70.426 },
  { raw_score: 7, interval_score: 67.516 },
  { raw_score: 8, interval_score: 64.664 },
  { raw_score: 9, interval_score: 61.815 },
  { raw_score: 10, interval_score: 58.93 },
  { raw_score: 11, interval_score: 55.985 },
  { raw_score: 12, interval_score: 52.965 },
  { raw_score: 13, interval_score: 49.858 },
  { raw_score: 14, interval_score: 46.652 },
  { raw_score: 15, interval_score: 43.335 },
  { raw_score: 16, interval_score: 39.902 },
  { raw_score: 17, interval_score: 36.363 },
  { raw_score: 18, interval_score: 32.735 },
  { raw_score: 19, interval_score: 29.009 },
  { raw_score: 20, interval_score: 25.103 },
  { raw_score: 21, interval_score: 20.805 },
  { raw_score: 22, interval_score: 15.633 },
  { raw_score: 23, interval_score: 8.104 },
  { raw_score: 24, interval_score: 0.0 },
];
